module.exports = __webpack_public_path__ + "7d7825c9680bf4c7a1cd8ebc096f3070.svg";